<template>
  <div id="contenedor-excel-conceptos-favoritos">
    <v-card v-if="$apollo.loading">
      <v-container>
        <v-row
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            Preparando exportación de conceptos...
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-form
      v-else
      ref="exportarConceposFavoritosContratosExcel"
      v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Exportar Conceptos Favoritos
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="seleccion"
            mandatory>
            <v-radio
              value="listadoActual">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Todos los Contratos</strong>
                </div>
              </template>
            </v-radio>
            <!-- <v-radio
              value="rangoFechas">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Rango de Fechas</strong>
                </div>
              </template>
            </v-radio> -->
          </v-radio-group>
          <v-row v-if="seleccion === 'rangoFechas'">
            <custom-date-picker
              v-model="rangoFechas.inicial"
              :rules="[mixReglas.requerido]"
              label="Fecha Inicial">
            </custom-date-picker>
            <custom-date-picker
              v-model="rangoFechas.final"
              :rules="[mixReglas.requerido]"
              label="Fecha Final">
            </custom-date-picker>
          </v-row>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            label="Exportar"
            tipo="formAceptar"
            :disabled="!formularioValido"
            :loading="estaCargando"
            @click="generarExcelConceposFavoritos">
          </custom-button>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CONTRATOS_EXCEL_CATALOGO_CONCEPTOS_FAVORITOS from '@/graphql/querys/administracion/contratos/contratosExcelConceptosFavoritos.gql';
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 4;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelConceptosFavoritos',
  mixins: [mixGenerarExceles],
  props: {},
  components: {
    CustomDatePicker,
    CustomButton,
  },
  apollo: {
    contratos: {
      query: CONTRATOS_EXCEL_CATALOGO_CONCEPTOS_FAVORITOS,
    },
  },
  data() {
    return {
      noData: [{ dato: '' }],
      formularioValido: false,
      estaCargando: false,
      seleccion: 'listadoActual',
      rangoFechas: {
        inicial: null,
        final: null,
      },
      nombreDocumento: 'CONCEPTOS FAVORITOS CONTRATOS',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
    };
  },
  methods: {
    async generarExcelConceposFavoritos() {
      const data = this.crearExcelConceptosFavoritos;
      await this.mixGenerarExcel(data);
    },
    cerrar() {
      this.$refs.exportarConceposFavoritosContratosExcel.reset();
      this.rangoFechas.inicial = null;
      this.rangoFechas.final = null;
      this.$emit('cerrar');
    },
  },
  computed: {
    getContratosCatalogoFavoritos() {
      if (!this.contratos) return [];
      return this.contratos;
    },
    getConceptosFavoritosPorContrato() {
      const conceptosFavoritosPorContrato = this.getContratosCatalogoFavoritos
        .map((contrato) => ({
          ...contrato,
          conceptosFavoritos: contrato.catalogoConceptos
            .filter((concepto) => concepto.esFavorito && concepto.tipo === 2)
            .sort((a, b) => (a.orden - b.orden)),
        }));
      return conceptosFavoritosPorContrato;
    },
    crearDatosDocumento() {
      const inicial = this.$moment(this.rangoFechas.inicial).format('DD-MM-YYYY');
      const final = this.$moment(this.rangoFechas.final).format('DD-MM-YYYY');
      const datosDocumento = [];
      datosDocumento.push(
        {
          value: 'CONCEPTOS FAVORITOS POR CONTRATO',
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 2,
            col: 7,
          },
        },
      );
      if (this.seleccion === 'rangoFechas') {
        datosDocumento.push(
          {
            value: `${inicial} AL ${final}`,
            row: 2,
            col: 1,
            estilo: {
              font: {
                size: 14,
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
            combinar: {
              row: 2,
              col: 7,
            },
          },
        );
      }
      return datosDocumento;
    },
    crearTablasConceptosPorFavoritosContrato() {
      const tablasConceptosPorContrato = [];
      let filaInicioTabla = filaInicioDatos;
      let columnaInicioTabla = 1;
      const titulosConceptos = [
        { texto: 'CLAVE', orden: 1 },
        { texto: 'DESCRIPCIÓN', orden: 2 },
        { texto: 'UNIDAD', orden: 3 },
        { texto: 'CANTIDAD', orden: 4 },
        { texto: 'PRECIO UNITARIO', orden: 5 },
        { texto: 'IMPORTE', orden: 6 },
        { texto: 'ESTIMADO', orden: 7 },
      ];
      this.getConceptosFavoritosPorContrato
        .forEach((contrato) => {
          if (contrato.conceptosFavoritos.length < 1) return;
          const datosContratos = [
            { texto: 'Numero de Contratro', dato: contrato.numero },
            { texto: 'Descripción', dato: contrato.meta },
            { texto: 'Contratista', dato: contrato.contratista.nombreRazonSocial },
            { texto: 'Fecha', dato: this.$moment(contrato.fecha).format('DD-MM-YYYY') },
            { texto: 'Importe', dato: contrato.importe },
          ];
          datosContratos.forEach((datoContrato) => {
            tablasConceptosPorContrato.push({
              value: datoContrato.texto,
              row: filaInicioTabla,
              col: columnaInicioTabla,
              estilo: {
                font: {
                  size: 14,
                  bold: true,
                },
                border: {
                  top: {
                    style: 'thin',
                    color: '000000',
                  },
                  bottom: {
                    style: 'thin',
                    color: '000000',
                  },
                  left: {
                    style: 'thin',
                    color: '000000',
                  },
                  right: {
                    style: 'thin',
                    color: '000000',
                  },
                },
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                  wrapText: true,
                },
              },
            },
            {
              value: datoContrato.dato,
              row: filaInicioTabla,
              col: columnaInicioTabla + 1,
              estilo: {
                font: {
                  size: 14,
                  bold: false,
                },
                border: {
                  top: {
                    style: 'thin',
                    color: '000000',
                  },
                  bottom: {
                    style: 'thin',
                    color: '000000',
                  },
                  left: {
                    style: 'thin',
                    color: '000000',
                  },
                  right: {
                    style: 'thin',
                    color: '000000',
                  },
                },
                alignment: {
                  horizontal: 'left',
                  vertical: 'center',
                },
              },
            });
            columnaInicioTabla += 2;
          });
          columnaInicioTabla = 1;
          filaInicioTabla += 1;
          titulosConceptos
            .sort((a, b) => (a.orden - b.orden))
            .forEach((titulo) => {
              tablasConceptosPorContrato.push({
                value: titulo.texto,
                row: filaInicioTabla,
                col: columnaInicioTabla,
                estilo: {
                  font: {
                    size: 12,
                    bold: true,
                  },
                  border: {
                    top: {
                      style: 'thin',
                      color: '000000',
                    },
                    bottom: {
                      style: 'thin',
                      color: '000000',
                    },
                    left: {
                      style: 'thin',
                      color: '000000',
                    },
                    right: {
                      style: 'thin',
                      color: '000000',
                    },
                  },
                  alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                  },
                },
              });
              columnaInicioTabla += 1;
            });
          columnaInicioTabla = 1;
          filaInicioTabla += 1;
          contrato.conceptosFavoritos.forEach((conceptoFavorito) => {
            const datosConceptos = [
              { dato: conceptoFavorito.clave, orden: 1 },
              { dato: conceptoFavorito.concepto, orden: 2 },
              { dato: conceptoFavorito.unidad, orden: 3 },
              { dato: conceptoFavorito.cantidad, orden: 4 },
              { dato: conceptoFavorito.precioUnitario, orden: 5 },
              { dato: conceptoFavorito.importe, orden: 6 },
              { dato: this.$ObjSumar(conceptoFavorito.estimado, 'importe'), orden: 7 },
            ];
            datosConceptos
              .sort((a, b) => (a.orden - b.orden))
              .forEach((datoConcepto) => {
                tablasConceptosPorContrato.push({
                  value: datoConcepto.dato,
                  row: filaInicioTabla,
                  col: columnaInicioTabla,
                  estilo: {
                    font: {
                      size: 12,
                      bold: false,
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: '000000',
                      },
                      bottom: {
                        style: 'thin',
                        color: '000000',
                      },
                      left: {
                        style: 'thin',
                        color: '000000',
                      },
                      right: {
                        style: 'thin',
                        color: '000000',
                      },
                    },
                    alignment: {
                      horizontal: 'left',
                      vertical: 'center',
                    },
                  },
                });
                columnaInicioTabla += 1;
              });
            columnaInicioTabla = 1;
            filaInicioTabla += 1;
          });
          filaInicioTabla += 2;
        });
      return tablasConceptosPorContrato;
    },
    crearHeaders() {
      return [{ value: '', row: 1 }];
    },
    crearExcelConceptosFavoritos() {
      const datosDocumento = this.crearDatosDocumento
        .concat(this.crearTablasConceptosPorFavoritosContrato);
      const bodyData = [...this.noData];
      const nombresColumnas = this.getColumnas;
      const dataHeaders = this.crearHeaders;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            // logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombresColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },

  },
};
</script>

<style>

</style>
